export type Modalitat = 'presencial' | 'virtual';

export enum ModalitatEnum {
  presencial = 'Presencial',
  virtual = 'Virtual',
}
